import {
  formatDateToLocale,
  formatIsoDateToLocale,
  parseToMysqlFormat,
  parseToMysqlTimeFormat,
} from '../../../../../services/util/date.service'
import { errorHandler } from '../../../../../services/util/error.service'
import * as ResumoHttp from '../../../../../services/api/https/picking/resumo-separcao.http'
import { useMemo, useState } from 'react'
import { getMotivoAtraso } from '../../../../../services/api/https/registration/motivo-atraso.http'
import { getUsuarioInfo } from '../../../../../services/localstorage/localstorage.service'
import { MOTIVO_ATRASO_URL_TYPES } from '../../../Cadastros/MotivoAtraso/MotivoAtrasoHook'
import {
  formatVolumeAndUnits,
  sumVolumeAndUnits,
} from '../../../../../services/util/volume-and-units.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  FINALIZANDO_RESUMO: 'Finalizando Resumo . . . ',
  GET_MOTIVOS: 'Adquirindo motivos de atraso',
  SUCCESS: 'Resumo Finalizado com Sucesso',
}

const INITIAL_PICKING = {
  t1_arrived_date: '',
  t1_arrived_time: '',
  t1_driver_name: '',
  t1_vehicle_plate: '',
  t1_data_operacao: '',
  codigo_lacre: '',
  data_operacao: '',
  transfer_vehicle_lated: false,
  motivo_atraso_id: '',
  arrived_date: '',
  obs_resumo_separacao: '',
}

const INITIAL_STATE = {
  nome_motorista: '',
  placa_veiculo: '',
  data_chegada: '',
  horario_chegada: '',
  data_operacao: '',
  t1_data_operacao: '',
  arrived_date: '',
  transfer_vehicle_lated: false,
  selectedMotivoAtraso: {},
  motivosAtraso: [],
  btnFinalizarDisabled: false,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedPicking: {
    ...INITIAL_PICKING,
  },
  isDisabled: false,
}

const MESSAGE_ERROR_INFO = {
  nome_motorista: 'Nome do Motorista incorreto',
  placa_veiculo: 'Placa do Veiculo incorreto',
  data_chegada: 'Data de Chegada incorreto',
  horario_chegada: 'Horario de Chegada incorreto',
  motivo_atraso_id: 'É Necessário Selecionar um Motivo de Atraso',
  data_operacao: 'Data de Operação incorreto',
}

export default function useEmitirResumo() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    const throwErrorForIncorrectInfo = fieldName => {
      setState(prevState => ({ ...prevState, errorMessage: MESSAGE_ERROR_INFO[fieldName] }))
    }

    const isNullOrBlank = string => !string || !string.trim()

    const summaryFieldsAreValid = ({
      codigo_lacre,
      temp_thermo_king,
      motivo_atraso_id,
      transfer_vehicle_lated,
      obs_resumo_separacao,
      ...info
    }) => {
      const summaryFields = Object.keys(info)
      if (transfer_vehicle_lated && !motivo_atraso_id) {
        throwErrorForIncorrectInfo('motivo_atraso_id')
        return false
      }
      let isValid = summaryFields.every((field, index) => {
        if (isNullOrBlank(info[field])) {
          throwErrorForIncorrectInfo(field)
          return false
        }
        return true
      })
      return isValid
    }

    const buildInfo = selectedPicking => {
      return {
        nome_motorista: selectedPicking.t1_driver_name,
        placa_veiculo: selectedPicking.t1_vehicle_plate
          ? selectedPicking.t1_vehicle_plate.toUpperCase()
          : '',
        data_chegada: selectedPicking.t1_arrived_date
          ? parseToMysqlFormat(selectedPicking.t1_arrived_date)
          : '',
        horario_chegada: selectedPicking.t1_arrived_time
          ? parseToMysqlTimeFormat(selectedPicking.t1_arrived_time)
          : '',
        codigo_lacre: selectedPicking.codigo_lacre,
        temp_thermo_king: selectedPicking.temp_thermo_king,
        data_operacao: selectedPicking.t1_data_operacao
          ? parseToMysqlFormat(selectedPicking.t1_data_operacao)
          : null,
        transfer_vehicle_lated: selectedPicking.transfer_vehicle_lated,
        motivo_atraso_id: selectedPicking.transfer_vehicle_lated
          ? selectedPicking.motivo_atraso_id
          : null,
        obs_resumo_separacao: selectedPicking.obs_resumo_separacao || null,
      }
    }

    const checkIsDisabled = selectedPicking => {
      if (selectedPicking) {
        const { style, status } = selectedPicking
        if (style === 'Codigo de Barra' || style === 'Reconferencia') {
          return status !== 'Picking Concluido'
        }
        if (style === 'Manual') {
          return status !== 'Com Entregas Associadas'
        }
        setState(prevState => ({
          ...prevState,
          errorMessage: `Tipo de Separação não identificada: ${style}. Contate o suporte`,
        }))
      }
      return false
    }

    const formatSelectedPickingDate = selectedPicking => {
      if (selectedPicking.t1_arrived_date !== null) {
        selectedPicking.arrived_date = selectedPicking.t1_arrived_date
          ? formatDateToLocale(selectedPicking.arrived_date, 'yyyy-MM-dd').toJSDate()
          : null
        selectedPicking.t1_data_operacao = selectedPicking.data_operacao
          ? formatIsoDateToLocale(selectedPicking.data_operacao).toJSDate()
          : null
      }
      return { ...selectedPicking }
    }

    const getQteMissingEfetiva = falta => {
      return falta.qte_missing_adjusted !== undefined
        ? falta.qte_missing_adjusted
        : falta.qte_missing
    }

    return {
      // Actions
      getMotivosAtraso(selectedTp) {
        getMotivoAtraso(getUsuarioInfo().id, selectedTp, MOTIVO_ATRASO_URL_TYPES.VEICULO_T1)
          .then(motivos =>
            setState(prevState => ({
              ...prevState,
              motivosAtraso: motivos,
              selectedMotivoAtraso: prevState.selectedPicking.motivo_atraso_id
                ? motivos.find(m => m.id === prevState.selectedPicking.motivo_atraso_id)
                : {},
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      finalizarResumo(selectedPicking) {
        const info = buildInfo(selectedPicking)
        if (summaryFieldsAreValid(info)) {
          ResumoHttp.finalizarResumoSeparacao(selectedPicking.id, info)
            .then(() => {
              setState(prevState => ({
                ...prevState,
                selectedPicking: selectedPicking,
                isDisabled: true,
                loadingMessage: LOAD_MESSAGE.SUCCESS,
              }))
            })
            .catch(e =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(e),
              })),
            )
        }
      },

      getTotalFaltas(faltasItems, tipo) {
        if (tipo === 'Codigo de Barra') {
          const faltas = faltasItems.reduce((items, item) => {
            if (Array.isArray(item.faltas) && item.faltas.length > 0) {
              items.push(...item.faltas.filter(falta => Number(getQteMissingEfetiva(falta)) < 0))
            }
            return items
          }, [])

          const result = sumVolumeAndUnits(faltas, falta => ({
            quantity: getQteMissingEfetiva(falta),
            unitSku: falta.unit_sku,
            caixaComPesoVariavel: falta.caixa_com_peso_variavel,
          }))

          return formatVolumeAndUnits(result)
        } else if (tipo === 'Manual') {
          const itemsWithFaltas = faltasItems.deliveries.map(d => {
            return d.items.filter(f => f.qte_missing_produto > 0)
          })
          const faltas = []
          itemsWithFaltas.forEach(f => {
            if (Array.isArray(f) && f.length > 0) {
              faltas.push(...f)
            }
          })
          return faltas.reduce((acc, value) => acc + value.qte_missing_produto, 0)
        } else {
          throw new Error('Tipo de Resumo NÃO definido.')
        }
      },

      getTotalSobras(sobrasItems) {
        const result = sumVolumeAndUnits(
          sobrasItems.filter(item => {
            const qteLeftover =
              item.qte_leftover_adjusted !== undefined
                ? item.qte_leftover_adjusted
                : Number(item.qte_leftover) + Number(item.qte_adjusted || 0)
            return Number(qteLeftover) > 0
          }),
          item => ({
            quantity:
              item.qte_leftover_adjusted !== undefined
                ? item.qte_leftover_adjusted
                : Number(item.qte_leftover) + Number(item.qte_adjusted || 0),
            unitSku: item.unit_sku,
            caixaComPesoVariavel: item.caixa_com_peso_variavel,
          }),
        )

        return formatVolumeAndUnits(result)
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
          loadingMessage: LOAD_MESSAGE.NONE,
          updatePicking: false,
        }))
      },

      // Events
      onInit(selectedPicking) {
        setState(prevState => ({
          ...prevState,
          selectedPicking: formatSelectedPickingDate({ ...selectedPicking }),
          isDisabled: checkIsDisabled(selectedPicking),
          loadingMessage: LOAD_MESSAGE.GET_MOTIVOS,
        }))
      },

      onInputChange(name, value) {
        setState(prevState => {
          prevState.selectedPicking[name] = value
          return { ...prevState }
        })
      },

      onMotivoChange(value) {
        setState(prevState => {
          prevState.selectedMotivoAtraso = value
          prevState.selectedPicking.motivo_atraso_id = value.id
          return { ...prevState }
        })
      },

      onInputDateChange(value) {
        setState(prevState => {
          prevState.selectedPicking.t1_arrived_date = value
          prevState.selectedPicking.arrived_date = value
          return { ...prevState }
        })
      },

      onBtnFinalizarResumo() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.FINALIZANDO_RESUMO,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
